module.exports = __webpack_public_path__ + "static/media/login.2ce2ee31.webp";